import { useEffect, useState } from "react";
import { fetchBlobUrl } from "@/lib/medicoes";

export default function AuthImage({ arquivoId, alt, className, onClick }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let url; let alive = true;
    fetchBlobUrl(`/medicoes/arquivos/${arquivoId}`)
      .then((u) => { url = u; if (alive) setSrc(u); })
      .catch(() => alive && setErr(true));
    return () => { alive = false; if (url) URL.revokeObjectURL(url); };
  }, [arquivoId]);
  if (err) return <div className={`${className} flex items-center justify-center text-[10px] text-[#94A3B8] bg-[#1E293B]`}>Pré-visualização indisponível</div>;
  if (!src) return <div className={`${className} animate-pulse bg-[#1E293B]`} />;
  return <img src={src} alt={alt} className={className} onClick={onClick} loading="lazy" onError={() => setErr(true)} />;
}
